import { authClient, API } from "../index";

// Get all localidades
export const getLocalidades = () => {
  return authClient().get(`${API}/localidad`);
};

// Get localidad by id
export const getLocalidadById = (id) => {
  return authClient().get(`${API}/localidad/${id}`);
};
